import gql from "graphql-tag";
import {useMemo} from "react";

import type {Result} from "@khanacademy/wonder-blocks-data";
import {useQuery} from "@repo/data-gql";
import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {Swag} from "../types.ts";

import type {aiGuideSwagQueryType} from "./__graphql-types__/index.ts";

export const AI_GUIDE_SWAG_CATALOGUE_QUERY: GqlOperation<
    aiGuideSwagQueryType["response"],
    aiGuideSwagQueryType["variables"]
> = gqlOp(gql`
    query aiGuideSwagQuery {
        aiGuideSwag {
            id
            name
            altText
            description
            price
        }
    }
`);

/**
 * Returns the result of the query which retrieves all possible AI Guide
 * fashion items.
 */
export const useGuideClosetItemCatalogue = (): Result<Array<Swag>> => {
    const [result] = useQuery(AI_GUIDE_SWAG_CATALOGUE_QUERY);

    return useMemo(() => {
        if (result.status !== "success") {
            return result;
        }

        return {
            status: "success",
            data: result.data.aiGuideSwag,
        };
    }, [result]);
};
